import { type OfferV11, type PimProductV11 } from '@redteclab/api/clients/bully'

import { productAccessorPharmaOblFlagIsTrue } from '../model/productAccessor/productAccessorPharmaOblFlagIsTrue'

import { useProductOrderLimitContext } from './components/productOrderLimitContext'
import { type ProductOrderLimitConfig } from './config/productOrderLimitPerTenantConfig'

const getProductStockQuantity = (
  currentOffer?: OfferV11,
): number | undefined => {
  if (currentOffer?.quantity) {
    return currentOffer.quantity
  }

  return undefined
}

const getOrderLimitForProduct = (
  product: PimProductV11,
  config: ProductOrderLimitConfig,
): number => {
  if (product.order_limit && product.order_limit > 0) {
    return product.order_limit * config.maxQuantityMultiplier
  }

  if (productAccessorPharmaOblFlagIsTrue(product)) {
    return config.maxQuantityOtc
  }

  return config.maxQuantityDefault
}

/**
 * returns max quantity that can be selected for quantity selection
 */
export const useProductMaxSelectableQuantity = ({
  offer,
  product,
}: {
  offer?: OfferV11
  product: PimProductV11
}): number => {
  const { config } = useProductOrderLimitContext()

  const orderLimit = getOrderLimitForProduct(product, config)
  const productStockQuantity = getProductStockQuantity(offer)

  // If marketplace, get lowest quantity taking in account the Mirakl Quantity
  if (productStockQuantity && productStockQuantity < orderLimit) {
    return productStockQuantity
  }

  return orderLimit
}
